import {
    color_grey_light,
    color_grey_ultra_light,
    color_red_default,
    color_transparent,
    color_white
} from "../../constants/colors";
import {OnestNormalDefault, OnestNormalSmall, OnestSemiBoldDefault} from "../styled/TextComponents";
import {BsArrowRight, BsQuestion} from "react-icons/bs";
import styled, {keyframes} from "styled-components";
import {useState} from "react";
import {useNavigate} from "react-router-dom";
import {
    getLevelBadgeLabel,
    getLevelEmojiSrc,
    getLevelSummary,
} from "../../constants/levels";
import ArrowIcon from "../icons/ArrowIcon";
import { useWindowDimensions } from "../../utils";

const keyFrames = keyframes`
    from {
        background-position: 128% -40%;
    }
    50% {
        background-position: 128% 0%;
    }
    to {
        background-position: 128% -40%;
    }
`

const BouncingDiv = styled.div`
    animation-name: "bounce-background";
    animation-timing-function: ease-in-out;
    animation-duration: 2s;
    animation-iteration-count: infinite;
    animation: ${props=>props.bouncing? keyFrames : null} 2s ease-in-out infinite;
`

export const LevelPreview = ({levelData, openLevelDescription}) => {
    const {height: screenHeight, width: screenWidth} = useWindowDimensions();
    
    const [bouncing, setBouncing] = useState(false);
    const navigate = useNavigate();

    return (
        <BouncingDiv
            bouncing={bouncing}
            onMouseEnter={()=>setBouncing(true)}
            onMouseLeave={()=>setBouncing(false)}
            style={{
                display: "flex",
                width: screenWidth > 440 ? 356 : screenWidth - 70,
                minHeight: screenWidth > 440 ? 300 : "max-content",
                height: "min-content",
                backgroundColor: color_white,
                borderRadius: 20,
                flexDirection: "column",
                gap: 20,
                padding: 25,
                boxSizing: "border-box",
                justifyContent: "flex-start",
                
                // animationName: "bounce-background",
                // animationTimingFunction: "ease-in-out",
                // animationDuration: "2s",
                // animationIterationCount: "infinite",
                // animation: `${bounse} 2s linear infinite`
            }}>
            <div style={{
                display: "flex",
                flexDirection: "row",
                //height: 158
            }}>
                <div style={{
                    display: "flex",
                    flexDirection: "column"
                }}>
                    <OnestSemiBoldDefault style={{fontSize: 25}}>
                        {Number.isFinite(Number(levelData.level)) ? `Level ${levelData.level}` : levelData.level}
                    </OnestSemiBoldDefault>
                </div>
            </div>
            <div style={{
                display: "flex",
                flexDirection: "row",
                gap: 20,
                justifyContent: "space-between",
                //marginBottom: 10,

            }}>
                <div style={{
                    //flex: 1,
                    height: 42,
                    width: "max-content",
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    alignContent: "center",
                    borderRadius: 20,
                    backgroundColor: color_grey_ultra_light,
                    padding: "0px 15px",
                    minHeight: "max-content"
                }}>
                    <img 
                        src={getLevelEmojiSrc(levelData)} 
                        alt={`Level ${levelData.level}`} 
                        style={{
                            width: 30, 
                            height: 30, 
                            marginRight: 10,
                            objectFit: "contain"
                        }} 
                    />
                    <OnestNormalDefault>{getLevelBadgeLabel(levelData)}</OnestNormalDefault>
                </div>
                {/*<div style={{flexWrap: 1}}></div>*/}
                <div style={{
                    display: "flex",
                    flexDirection: "row",
                    gap: 5
                }}>
                  
                    <div style={{
                        backgroundColor: color_red_default,
                        border: `1px solid ${color_transparent}`,
                        borderRadius: "50%",
                        display: "flex",
                        justifyContent: "center",
                        alignContent: "center",
                        alignItems: "center",
                        width: 40,
                        height: 40,
                        color: color_white,
                        fontSize: 30,
                        cursor: "pointer",
                    }} onClick={()=>navigate(`/service/program/level/${levelData.id}`)}>
                        <ArrowIcon fill={color_grey_ultra_light}/>
                    </div>
                </div>
            </div>
            <OnestNormalSmall>{getLevelSummary(levelData)}</OnestNormalSmall>

        </BouncingDiv>
    )
}